
export function set(name: string, value: any, expiration: Date) {
    document.cookie = `${name}=${JSON.stringify(value)}; expires=${expiration.toUTCString()}; path=/;`;
}

export function get(name: string) {
    const cookie = document.cookie.match(new RegExp(name + '=([^;]+)'));
    if (cookie) {
        return (Array.isArray(cookie)) ? cookie[1] : JSON.parse(cookie[1]);
    }
    return null;
}

export function remove(name: string) {
    document.cookie = `${name}=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/;`;
}

const Cookie = {
    get,
    set,
    remove
};

export default Cookie;